import React from 'react';
import styles from './LoadingSkeleton.module.css';

function LoadingSkeleton({ rows = 3, type = 'text' }) {
  if (type === 'card') {
    return (
      <div className={styles.cardGrid}>
        {Array.from({ length: rows }, (_, i) => (
          <div key={i} className={styles.card}>
            <div className={styles.titleBar} />
            <div className={styles.line} />
            <div className={styles.lineShort} />
          </div>
        ))}
      </div>
    );
  }

  if (type === 'stat') {
    return (
      <div className={styles.statGrid}>
        {Array.from({ length: rows }, (_, i) => (
          <div key={i} className={styles.stat}>
            <div className={styles.label} />
            <div className={styles.value} />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={styles.textBlock}>
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className={styles.line} style={{ width: `${85 - i * 15}%` }} />
      ))}
    </div>
  );
}

export default LoadingSkeleton;
